/* Spanish widget controls only. Customer review titles and bodies stay original. */
(function() {
  'use strict';
  if (document.documentElement.lang.split('-')[0] !== 'es') return;
  var roots = '.jdgm-widget, .jdgm-review-widget-modal';
  var controls = '[aria-label], [title], [placeholder], label, button';
  var watched = new WeakSet();
  var translations = {
    'Sort reviews by': 'Ordenar reseñas por',
    'Pagination Navigation': 'Navegación de reseñas',
    'Go to previous page': 'Ir a la página anterior',
    'Go to next page': 'Ir a la página siguiente',
    'Close review form': 'Cerrar formulario de reseña',
    'Rating': 'Calificación',
    'Previous step': 'Paso anterior',
    'Next step': 'Paso siguiente'
  };
  function translate(value) {
    if (translations[value]) return translations[value];
    var match = value && value.match(/^Go to page (\d+)$/);
    if (match) return 'Ir a la página ' + match[1];
    match = value && value.match(/^([\d.,]+) out of 5 stars$/);
    if (match) return match[1] + ' de 5 estrellas';
    match = value && value.match(/^(\d+) stars?$/);
    return match ? match[1] + (match[1] === '1' ? ' estrella' : ' estrellas') : value;
  }
  function localize(root) {
    if (root.nodeType !== 1) return;
    var nodes = Array.prototype.slice.call(root.querySelectorAll(controls));
    if (root.matches(controls)) nodes.push(root);
    nodes.forEach(function(el) {
      ['aria-label', 'title', 'placeholder'].forEach(function(attr) {
        var value = el.getAttribute(attr), next = translate(value);
        if (value !== next) el.setAttribute(attr, next);
      });
      if (el.tagName === 'LABEL' && /^jdgm-sort-/.test(el.htmlFor) && el.textContent.trim() === 'Sort reviews by') el.textContent = translations['Sort reviews by'];
    });
  }
  function observe(root) {
    if (watched.has(root)) return;
    watched.add(root);
    localize(root);
    new MutationObserver(function(records) {
      records.forEach(function(record) {
        if (record.type === 'attributes') localize(record.target);
        else Array.prototype.forEach.call(record.addedNodes, function(node) { if (node.nodeType === 1) localize(node); });
      });
    }).observe(root, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-label', 'title', 'placeholder']});
  }
  document.querySelectorAll(roots).forEach(observe);
  new MutationObserver(function(records) {
    records.forEach(function(record) {
      Array.prototype.forEach.call(record.addedNodes, function(node) {
        if (node.nodeType !== 1 || node.parentElement && node.parentElement.closest(roots)) return;
        if (node.matches(roots)) observe(node);
        node.querySelectorAll(roots).forEach(observe);
      });
    });
  }).observe(document.body, {childList: true, subtree: true});
})();
